<template>
    <div>
        <div>
            <div class="extraBox store text-center cursor" @click="showModal()">
                <template v-if="loading">
                  <i aria-hidden="true" class="fa fa-spin fa-circle-o-notch mb-3 mt-1"></i>
                </template>
                <template v-else>
                  <i aria-hidden="true" class="fa fa-home mb-3 mt-1"></i>
                </template>
                <div v-html="$translate('Bigtex5::Template.storeButton')"></div>
            </div>
        </div>
        <div class="modal fade stocks" ref="stocks" tabindex="-1" role="dialog">
<!--          top 50-->
            <div class="modal-dialog" style="top:50px">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">{{ $translate("Bigtex5::Template.storeHeadline") }}</h3>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" :aria-label="$translate('Ceres::Template.closeIcon')">&times;</button>
                    </div>
                    <div class="modal-body">
                      <template v-if="variations.length > 0">
                        <table class="table table-striped">
                          <tbody>
                            <tr v-for="(variation,index) in variations" :key="index" v-if="variation.stock.length > 0">
                              <td class="w-50">
                                {{ variation.attrValues[0].name }}
                              </td>
                              <td class="w-50 text-right">
                                  <span class="text-green">{{ $translate("Bigtex5::Template.storeavailable") }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </template>
                      <template v-else>
                        <div class="p-3 text-center" style="background-color:#f0f0f0;">
                          {{ $translate("Bigtex5::Template.storenotavailable") }}
                        </div>
                      </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default
    {
        inject:
        {
            itemId:
            {
                default: null
            }
        },
        props:['stock'],
        data: function()
        {
            return {
                variations:[],
                loaded:false,
                loading:false
            }
        },
        methods:
        {
            showModal:function()
            {
              let _self = this;
              if(!this.loaded)
              {
                this.loading = true;
                $.ajax(
                    {
                      type: 'GET',
                      url: '/warehouse/item/' + this.itemId + '/',
                      success: function (data)
                      {
                        _self.loading = false;
                        _self.loaded = true;
                        let toReturn = [];
                        for (let i = 0; i < data.length; i++) {
                          if (data[i].stock.length > 0)
                          {
                            let pushit = false;
                            for(let i2 = 0; i2 < data[i].stock.length; i2++)
                            {
                              if(data[i].stock[i2].quantity > 0)
                              {
                                pushit = true
                              }
                            }
                            if(pushit)
                            {
                              toReturn.push(data[i]);
                            }
                          }
                        }
                        _self.variations = toReturn;
                        $('.stocks').modal("show");
                      }
                    });
              }
              else
              {
                $('.stocks').modal("show");
              }
            },

        }
    }
</script>
